import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  useToast,
  Text,
  VStack,
  Icon,
  Switch,
  FormControl,
  FormLabel,
  HStack,
} from '@chakra-ui/react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import GrillaEffect from "views/Grillas/GrillaEffect";
import dayjs from "dayjs";
import 'dayjs/locale/es';
import { IconButton } from '@mui/material';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { useHistory } from 'react-router-dom';
registerLocale("es", es);
const theme = createTheme({
  palette: {}
});

const ConciliarOps = () => {
  const defaultFecha = [
    { id: 'fecha_valor', value: [dayjs().subtract(60, 'days'), dayjs(new Date())] }
  ];
  const [registros, setRegistros] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  // NUEVO: Estado para el switch de validación de palabras
  const [validarPalabras, setValidarPalabras] = useState(true);
  const toast = useToast();
  const history = useHistory();

  // CAMBIO: Actualizar datos cuando cambie el switch
  useEffect(() => {
    if (registros.length > 0) {
      // Refrescar datos cuando cambie la validación de palabras
      handleSearch();
    }
  }, [validarPalabras]);

  useEffect(() => {
    //handleSearch();
  }, [filters]);

  const handleSearch = async () => {
    setIsLoading(true);
    try {
      // CAMBIO: Agregar parámetro de validación de palabras
      const baseURL = `${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/items/extbc-lops-coincidencias?filters=${encodeURIComponent(JSON.stringify(filters))}&validar_palabras=${validarPalabras}`;
      const response = await fetch(baseURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": localStorage.getItem("token"),
        },
      });

      if (response.ok) {
        const data = await response.json();
        setRegistros(data.data);
      } else {
        throw new Error(`Error: ${response.statusText}`);
      }
    } catch (error) {
      console.error('Error fetching registros:', error);
      toast({
        title: 'Error al buscar coincidencias.',
        description: `No se pudo buscar coincidencias.`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleConciliar = async (id_registro, registroExtbc) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/items/registros/conciliar`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": localStorage.getItem("token"),
        },
        body: JSON.stringify({ idRegistroLops: id_registro, idRegistroExtbc: registroExtbc }),
      });

      if (response.ok) {
        toast({
          title: 'Registro conciliado.',
          description: `Los registros con ID ${id_registro} e ${registroExtbc} fueron conciliados.`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        handleSearch(); // Refresh data
      } else {
        throw new Error(`Error: ${response.statusText}`);
      }
    } catch (error) {
      console.error('Error conciliando registros:', error);
      toast({
        title: 'Error al conciliar registros.',
        description: `No se pudo conciliar los registros.`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Conciliar múltiples registros seleccionados
  const handleConciliarMultiple = async () => {
    if (selectedRows.length === 0) return;
    setIsLoading(true);
    try {
      for (const row of selectedRows) {
        // row: { id_registro, registroExtbc }
        await handleConciliar(row.id_registro, row.registroExtbc);
      }
      setSelectedRows([]);
      await handleSearch();
    } catch (error) {
      // El toast de error ya está en handleConciliar
    } finally {
      setIsLoading(false);
    }
  };

  // CAMBIO: Función para limpiar todos los filtros
  const handleClearFilters = () => {
    setFilters([]);
    toast({
      title: 'Filtros limpiados',
      description: 'Se han eliminado todos los filtros aplicados.',
      status: 'info',
      duration: 2000,
      isClosable: true,
    });
  };

  // CAMBIO: Componente para mostrar cuando no hay resultados
  const NoResultsMessage = () => (
    <VStack spacing={4} p={8} textAlign="center">
      <Icon as={SearchOffIcon} boxSize={12} color="gray.400" />
      <Text fontSize="lg" color="gray.600">
        No se encontraron coincidencias con los filtros aplicados
      </Text>
      <Text fontSize="sm" color="gray.500">
        Intenta ajustar los criterios de búsqueda o limpiar los filtros
      </Text>
      <Button
        leftIcon={<ClearAllIcon />}
        colorScheme="blue"
        variant="outline"
        onClick={handleClearFilters}
      >
        Limpiar todos los filtros
      </Button>
    </VStack>
  );

  // CAMBIO: Función para manejar el cambio del switch
  const handleSwitchChange = () => {
    const nuevoValor = !validarPalabras;
    setValidarPalabras(nuevoValor);
    toast({
      title: nuevoValor ? 'Validación de palabras activada' : 'Validación de palabras desactivada',
      description: nuevoValor 
        ? 'Se mostrarán solo coincidencias con palabras en común' 
        : 'Se mostrarán todas las coincidencias por importe y fecha',
      status: 'info',
      duration: 2000,
      isClosable: true,
    });
  };

  // CAMBIO: Custom toolbar con botón de validación de palabras
  const customTopToolbar = (
    <Box display="flex" alignItems="center" gap={2}>
      <IconButton
        color="primary"
        disabled={selectedRows.length === 0}
        onClick={handleConciliarMultiple}
        title="Conciliar Seleccionados"
        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <DoneAllIcon sx={{ mr: 1 }} />
        Conciliar Seleccionados
      </IconButton>
      <IconButton
        color="secondary"
        disabled={filters.length === 0}
        onClick={handleClearFilters}
        title="Limpiar Filtros"
        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <ClearAllIcon sx={{ mr: 1 }} />
        Limpiar Filtros
      </IconButton>
      <IconButton
        color={validarPalabras ? "success" : "warning"}
        onClick={handleSwitchChange}
        title={validarPalabras ? "Desactivar validación de palabras" : "Activar validación de palabras"}
        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <SearchOffIcon sx={{ mr: 1 }} />
        {validarPalabras ? 'Con Validación' : 'Sin Validación'}
      </IconButton>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => history.push('/admin/registros-conciliados')}
      >
        Ver registros conciliados
      </Button>
      <span>
        {selectedRows.length > 0 ? `${selectedRows.length} seleccionados` : ''}
        {filters.length > 0 && ` | ${filters.length} filtros aplicados`}
      </span>
    </Box>
  );

  // Callback para selección de filas desde GrillaEffect
  const onRowSelectionChange = (rowSelection, table) => {
    // rowSelection es un objeto {rowId: true, ...}
    // table.getRowModel().rows es el array de filas visibles
    const selected = Object.keys(rowSelection)
      .filter(rowId => rowSelection[rowId])
      .map(rowId => table.getRowModel().rows.find(r => r.id === rowId)?.original)
      .filter(Boolean);
    setSelectedRows(selected);
  };

  // Columnas y headers para GrillaEffect
  const columnNames = {
    num_comprobante: "OP N°",
    fecha_movimiento: "Fecha OP", // <-- Nueva columna como segunda
    razonSocial: "Razón Social",
    debito: "Importe OP",
    fecha_valor: "Fecha Reg. EXTBCO",
    descripcion: "Descripcion EXTBCO",
    importe: "Importe EXTBCO",
    descripcionConcepto: "Cta Bco",
    accionesCO: "Acciones",
  };

  const colsGrillaHidden = {
    id_registro: false,
    id_comprobante: false,
    registroExtbc: false,
    id_registro_conciliado: false,
    debitoExtbc: false,
  };

  return (
    <Box p={4} mt="22%">
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
        <ThemeProvider theme={theme}>
          {/* CAMBIO: Mostrar mensaje cuando no hay resultados */}
          {registros.length === 0 && !isLoading && filters.length > 0 ? (
            <NoResultsMessage />
          ) : (
            <GrillaEffect
              data={registros}
              updateData={setRegistros}
              filters={filters}
              updateFilters={setFilters}
              colsHeaders={columnNames}
              hiddenColumns={colsGrillaHidden}
              method='GET'
              baseURI={`${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/items/extbc-lops-coincidencias`}
              handleConciliar={handleConciliar}
              customTopToolbar={customTopToolbar}
              onRowSelectionChange={onRowSelectionChange}
              isLoading={isLoading}
              // NUEVO: Pasar el parámetro de validación de palabras
              additionalParams={{ validar_palabras: validarPalabras }}
              rowSelectionEnabled={true}
            />
          )}
        </ThemeProvider>
      </LocalizationProvider>
    </Box>
  );
};

export default ConciliarOps;